export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-tachometer-alt'
    },
    {
      name: 'Sales Log',
      url: '/sales',
      icon: 'fa fa-shopping-cart'
    },
    {
      name: 'Product',
      url: '/product',
      icon: 'fa fa-box-open',
      children: [
        {
          name: 'Product List',
          url: '/product/list',
          icon: 'fa fa-boxes'
        },
        {
          name: 'Parent Product',
          url: '/product/parent',
          icon: 'fa fa-box'
        }
      ]
    },
    {
      name: 'Inventory',
      url: '/inventory',
      icon: 'fa fa-boxes',
      children: [
        {
          name: 'Inbound',
          url: '/inventory/inbound',
          icon: 'fa fa-dolly-flatbed'
        }
      ]
    },
    {
      name: 'Customer',
      url: '/customer',
      icon: 'fa fa-users',
      children: [
        {
          name: 'Partners',
          url: '/customer/partners',
          icon: 'fas fa-people-carry'
        },
        {
          name: 'Customer List',
          url: '/customer/list',
          icon: 'fa fa-user-circle'
        }
      ]
    },
    {
      name: 'Report',
      url: '/report',
      icon: 'fa fa-chart-pie',
      children: [
        {
          name: 'Daily Report',
          url: '/report/daily',
          icon: 'fa fa-chart-bar'
        },
        {
          name: 'Sales Report',
          url: '/report/sales',
          icon: 'fa fa-chart-line'
        },
        {
          name: 'Stock Movement',
          url: '/report/stock',
          icon: 'fa fa-shipping-fast'
        },
        {
          name: 'Geo Report',
          url: '/report/geo',
          icon: 'far fa-map'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js